const keyBy = require('lodash/keyBy')

function groupWarehouseProductsByGenericId ({
  sellPrices = [],
  ledger = {},
  genericMetaBySku = {}
} = {}) {
  // Index sell prices by productId for quick lookup.
  const sellPricesByProductId = keyBy(sellPrices, entry => entry.productId)

  const ledgerByProductId = Object.keys(ledger).reduce((acc, key) => {
    acc[key] = ledger[key]
    return acc
  }, {})

  // Price list is the source of truth for which products to return.
  const allProductIds = new Set(Object.keys(sellPricesByProductId))

  // Group products by generic_id (generic parent).
  const groupsByKey = {}
  for (const productId of allProductIds) {
    const genericMeta = genericMetaBySku[productId] || {}
    const {
      genericParent,
      genericFactor,
      genericName,
      name,
      unitOfIssue,
      unitOfReporting,
      presentationType,
      packagingType,
      genericPresentation
    } = genericMeta

    // If generic_id is missing (For SL clients), treat each sku as its own group.
    const groupKey = (!genericParent || genericParent === null)
      ? productId
      : `product:${genericParent}`

    if (!groupsByKey[groupKey]) {
      groupsByKey[groupKey] = {
        genericId: groupKey,
        genericName: genericName || null,
        products: []
      }
    }

    const sellPriceEntry = sellPricesByProductId[productId] || {}
    groupsByKey[groupKey].products.push({
      productId,
      name,
      genericFactor,
      unitOfIssue,
      unitOfReporting,
      presentationType,
      packagingType,
      sellPrice: sellPriceEntry.sellPrice,
      genericPresentation,
      ledger: ledgerByProductId[productId]
    })
  }

  return Object.values(groupsByKey)
}

exports.groupWarehouseProductsByGenericId = groupWarehouseProductsByGenericId
